<template lang="pug">
.container-restrictions()
  .row.section-title
    p {{ $t('Dates') }}
  .row
    .column.column-left
      span {{ $t('From:') }}
    .column.column-right
      span {{ $t('To:') }}
  .row(v-for='(restriction, index) in sortedDateRestrictions', :key='restriction.id', :id="'ScheduleDateEditor-restrictionRow' + restriction.id")
    .column.column-left
      el-date-picker(:picker-options="{ firstDayOfWeek: 1 }", v-model="dateRestrictions[index].firstPlayDate", @change='changedRow(restriction.id)', type="datetime", format='yyyy-MM-dd HH:mm', :placeholder="$t('Play from date/time')", :id="'ScheduleDateEditor-datePickerFromRestriction' + restriction.id")
    .column.column-right
      el-date-picker(:picker-options="{ firstDayOfWeek: 1 }", v-model="dateRestrictions[index].lastPlayDate", @change='changedRow(restriction.id)', type="datetime", format='yyyy-MM-dd HH:mm', :placeholder="$t('Play to date/time')", :id="'ScheduleDateEditor-datePickerToRestriction' + restriction.id")
    .column.column-buttons
      el-button.button(
        :id="'ScheduleDateEditor-deleteRestriction' + restriction.id + 'Button'",
        type="success",
        size="mini",
        @click="deleteDateRestriction(restriction.id)",
      )
        span
          font-awesome-icon.icon(v-if="isDeleting !== restriction.id", icon='minus')
          font-awesome-icon.icon.fa-spin(v-else, icon='spinner')
          span &nbsp; {{ $t(isDeleting !== restriction.id ? 'delete' : 'deleting') }}
      el-button.button.spinner(
        :id="'ScheduleDateEditor-saveRestriction' + restriction.id + 'Button'",
        type="success",
        size="mini",
        @click="modifyDateRestriction(restriction.id)",
        :ref="'save' + restriction.id"
      )
        span
          font-awesome-icon.icon(v-if="isSaving !== restriction.id", icon='save')
          font-awesome-icon.icon.fa-spin(v-else, icon='spinner')
          span &nbsp; {{ $t(isSaving !== restriction.id ? 'save' : 'saving') }}
  .row(id="ScheduleDateEditor-newRestrictionRow")
    .column.column-left
      el-date-picker(
        :picker-options="{ firstDayOfWeek: 1 }",
        :id="model + 'ScheduleDateEditor-fromDatePicker'",
        v-model="newDateRestriction.firstPlayDate",
        type="datetime",
        format='yyyy-MM-dd HH:mm',
        :placeholder="$t('Play from date/time')"
      )
    .column.column-right
      el-date-picker(
        :picker-options="{ firstDayOfWeek: 1 }",
        :id="model + 'ScheduleDateEditor-toDatePicker'",
        v-model="newDateRestriction.lastPlayDate",
        type="datetime",
        format='yyyy-MM-dd HH:mm',
        :placeholder="$t('Play to date/time')"
      )
    .column.column-buttons
      el-button.button(
        :id="model + 'ScheduleDateEditor-addRestrictionButton'",
        type="success",
        size="mini",
        @click="addDateRestriction('userForm')",
        :disabled='!__validateInput()'
      )
        span
          font-awesome-icon.icon(v-if="!isAdding", icon='plus')
          font-awesome-icon.icon.fa-spin(v-else, icon='spinner')
          span &nbsp; {{ $t(!isAdding ? 'add' : 'adding') }}
</template>

<script>
import Vue from 'vue'
export default {
  props: ['item', 'model'],
  mounted () {
  },
  data () {
    return {
      newDateRestriction: {
        firstPlayDate: null,
        lastPlayDate: null
      },
      dateRestrictions: JSON.parse(JSON.stringify(this.item[`${this.model}_DateRestrictions`])),
      changed: {},
      isSaving: null,
      isDeleting: null,
      isAdding: false
    }
  },
  methods: {
    changedRow (restrictionId) {
      this.$refs['save' + restrictionId][0].$el.classList.remove('invisible')
    },
    __validateInput () {
      if (!this.newDateRestriction.firstPlayDate && !this.newDateRestriction.lastPlayDate) {
        return false
      }
      return true
    },
    async modifyDateRestriction (restrictionId) {
      if (this.isSaving !== null) return
      this.isSaving = restrictionId
      const path = `${this.model}_DateRestriction/` + restrictionId
      const restrictionIndex = this.dateRestrictions.findIndex(restriction => restriction.id === restrictionId)
      const modifiedRestriction = this.dateRestrictions[restrictionIndex]
      modifiedRestriction.firstPlayDate = modifiedRestriction.firstPlayDate ? this.$moment(modifiedRestriction.firstPlayDate).format('YYYY-MM-DD HH:mm:ss') : ''
      modifiedRestriction.lastPlayDate = modifiedRestriction.lastPlayDate ? this.$moment(modifiedRestriction.lastPlayDate).format('YYYY-MM-DD HH:mm:ss') : ''
      await Vue.axios
        .patch(path, {
          firstPlayDate: modifiedRestriction.firstPlayDate ? modifiedRestriction.firstPlayDate : '',
          lastPlayDate: modifiedRestriction.lastPlayDate ? modifiedRestriction.lastPlayDate : ''
        })
        .then(response => {
          this.dateRestrictions.splice(restrictionIndex, 1, response.data)
          this.$refs['save' + restrictionId][0].$el.classList.add('invisible')
        })
      this.isSaving = null
    },
    async deleteDateRestriction (restrictionId) {
      if (this.isDeleting !== null) return
      this.isDeleting = restrictionId
      const path = `${this.model}_DateRestriction/` + restrictionId
      await Vue.axios
        .delete(path)
        .then(response => {
          const restrictionIndex = this.dateRestrictions.findIndex(restriction => restriction.id === restrictionId)
          this.dateRestrictions.splice(restrictionIndex, 1)
        })
      this.isDeleting = null
    },
    async addDateRestriction () {
      if (this.isAdding) return
      this.isAdding = true
      if (!this.$moment(this.newDateRestriction.firstPlayDate).isValid()) {
        this.newDateRestriction.firstPlayDate = ''
      } else {
        this.newDateRestriction.firstPlayDate = this.$moment(this.newDateRestriction.firstPlayDate).format('YYYY-MM-DD HH:mm:ss')
      }
      if (!this.$moment(this.newDateRestriction.lastPlayDate).isValid()) {
        this.newDateRestriction.lastPlayDate = ''
      } else {
        this.newDateRestriction.lastPlayDate = this.$moment(this.newDateRestriction.lastPlayDate).format('YYYY-MM-DD HH:mm:ss')
      }
      this.newDateRestriction[this.model] = this.item.id
      if (!this.__validateInput()) return
      const path = `${this.model}_DateRestriction/`
      await Vue.axios
        .post(path, this.newDateRestriction)
        .then(response => {
          this.newDateRestriction.firstPlayDate = null
          this.newDateRestriction.lastPlayDate = null
          this.dateRestrictions.push(response.data)
        })
      this.isAdding = false
    }
  },
  computed: {
    sortedDateRestrictions () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dateRestrictions
        .sort((a, b) => (a.firstPlayDate > b.firstPlayDate) ? 1 : ((b.firstPlayDate > a.firstPlayDate) ? -1 : 0))
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container-restrictions {
  display: flex;
  flex-direction: column;
  font-size: $--font-size-base;
  margin: auto;
  width: 95%;
  border-bottom: 1px $--border-style-base rgba($--border-color-extra-light, 0.2);
  padding-bottom: 10px;
  margin-bottom: 10px;
  .row {
    display: flex;
    &.section-title {
      font-size: $--font-size-big;
      font-weight: bold;
      // color: $--color-warning;
      // text-transform: uppercase;
    }
    .column {
      &.column-left, &.column-right {
        width: 230px;
      }
      &.column-left {
        margin-left: 265px;
      }
      &.column-buttons {
        display: flex;
        align-items: center;
        .button {
          max-height: 30px;
          width: 95px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/ScheduleDateEditor.vue